import httpRequest from '../../common/lib/http-request';

// *******************
// SUPPORT SERVICES
// *******************

function submitSupportRequest(request) {
    return httpRequest({
        url: '/ServiceDesk/Contact',
        method: 'POST',
        data: request
    }, false, process.env.REACT_APP_SUPPORT_API_URL);
}

const SupportService = { submitSupportRequest }

export default SupportService;